// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full-page centering */
.login-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f6f8;
}

/* Login card */
.login {
  width: 360px;
  background: white;
  padding: 32px;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
}

/* Title */
.login h2 {
  text-align: center;
  margin-bottom: 24px;
  font-weight: 600;
  color: #1e3a8a;
}

/* Inputs */
.login-page .login input {
  width: 92%;
  height: 42px;
  padding: 0 14px;
  margin-bottom: 14px;

  border: 1px solid #94a3b8;
  border-radius: 8px;

  font-size: 14px;
  color: #1f2937;

  background: #f8fbff;
  box-shadow:
    inset 0 1px 2px rgba(0, 0, 0, 0.08),
    0 1px 1px rgba(0, 0, 0, 0.02);

  transition: all 0.2s ease;
}

.login-page .login input:focus {
  outline: none;
  background: #ffffff;
  border-color: #2563eb;
  box-shadow:
    0 0 0 3px rgba(37, 99, 235, 0.18),
    inset 0 1px 2px rgba(0, 0, 0, 0.06);
}


/* Button */
.login button {
  width: 100%;
  padding: 10px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
}

.login button:hover {
  background: #1d4ed8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/auth.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;;EAElB,eAAe;EACf,cAAc;;EAEd,mBAAmB;EACnB;;iCAE+B;;EAE/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB;;uCAEqC;AACvC;;;AAGA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Full-page centering */\n.login-page {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f4f6f8;\n}\n\n/* Login card */\n.login {\n  width: 360px;\n  background: white;\n  padding: 32px;\n  border-radius: 10px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);\n}\n\n/* Title */\n.login h2 {\n  text-align: center;\n  margin-bottom: 24px;\n  font-weight: 600;\n  color: #1e3a8a;\n}\n\n/* Inputs */\n.login-page .login input {\n  width: 92%;\n  height: 42px;\n  padding: 0 14px;\n  margin-bottom: 14px;\n\n  border: 1px solid #94a3b8;\n  border-radius: 8px;\n\n  font-size: 14px;\n  color: #1f2937;\n\n  background: #f8fbff;\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.08),\n    0 1px 1px rgba(0, 0, 0, 0.02);\n\n  transition: all 0.2s ease;\n}\n\n.login-page .login input:focus {\n  outline: none;\n  background: #ffffff;\n  border-color: #2563eb;\n  box-shadow:\n    0 0 0 3px rgba(37, 99, 235, 0.18),\n    inset 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n\n/* Button */\n.login button {\n  width: 100%;\n  padding: 10px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.login button:hover {\n  background: #1d4ed8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
